class Utils {
    public static register() {

        // Found at this url http://stackoverflow.com/questions/1144783/replacing-all-occurrences-of-a-string-in-javascript
        String.prototype.replaceAll = function (search: string, replacement: string) {
            return this.replace(new RegExp(search, 'g'), replacement);
        };
        
        _.mixin({
            skipTake: function (array: any, options: any) {
                options = _.extend({ skip: 0, take: 0 }, options || {});

                return _(array)
                    .chain()
                    .rest(options.skip)
                    .first(options.take || array.length - options.skip)
                    .value();
            }
        });
    }
}

Utils.register();
